import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { Store } from '@ngrx/store';

import { User } from 'lingo2-models';
import { takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule],
})
export class WelcomeComponent extends AbstractPane implements OnInit {
  public firstName: string;
  protected me: User;

  protected store = inject(Store);

  ngOnInit() {
    this.contextService.me$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (me) => {
        this.me = me;
        this.firstName = me.first_name;
        this.markForCheck();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
      },
    });
  }

  hasContent(): boolean {
    return !!this._pane;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }
}
